import * as React from "react";
import { useAuth } from "../auth/AuthProvider";

export default function SignInGate() {
  const { login, loading, error } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6 py-10">
      <div className="w-full max-w-xs text-center">
        <img
          src="/assets/logo.png"
          alt="ESI Flow"
          className="mx-auto h-14 w-14 rounded-lg ring-1 ring-brand-100 shadow-sm mb-5"
        />
        <h1 className="text-lg font-semibold text-gray-900 tracking-tight">
          ESI Flow for Word
        </h1>
        <p className="text-sm text-gray-600 mt-1.5 leading-6">
          Analyze clauses, run jurisdiction checks, generate talking points,
          and get AI-powered assistance on your legal documents — without
          leaving Word.
        </p>
        <p className="text-xs text-gray-500 mt-3 leading-5">
          Sign in with your Microsoft work or school account to get started.
        </p>

        <button
          type="button"
          onClick={() => {
            login().catch(() => {
              /* error already surfaced via context */
            });
          }}
          disabled={loading}
          className="mt-6 inline-flex items-center justify-center gap-2 w-full rounded-md bg-brand-500 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-medium px-4 py-2.5 transition-colors shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-1"
        >
          {loading ? (
            <span
              className="inline-block w-4 h-4 rounded-full border-2 border-white/40 border-t-white animate-spin"
              aria-hidden
            />
          ) : (
            <svg
              viewBox="0 0 21 21"
              className="w-4 h-4"
              aria-hidden
            >
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
          )}
          {loading ? "Signing in" : "Sign in with Microsoft"}
        </button>

        {error && (
          <p
            className="mt-3 text-xs text-red-600 leading-5"
            role="alert"
            aria-live="polite"
          >
            {error}
          </p>
        )}

        <p className="mt-6 text-xs text-gray-400 leading-5">
          <a
            href="https://www.esiflow.com/help-page/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-600 hover:text-brand-700 underline"
          >
            Learn more
          </a>
          {" · "}
          <a
            href="https://www.esiflow.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-600 hover:text-brand-700 underline"
          >
            Privacy
          </a>
        </p>
      </div>
    </div>
  );
}
